import sanitizeHtml from "sanitize-html";

compiler('[check-api-auth]', (button) => {
  const buttonOriginalText = button.innerHTML;
  button.addEventListener('click', check_api_status);

  async function check_api_status() {
    button.disabled = true;
    button.innerHTML = "<i class=\"fa-solid fa-spinner fa-spin me-1\"></i>" + sanitizeHtml(buttonOriginalText);

    const settingType = button.getAttribute("check-api-auth")
    let credentials = getCredentials(settingType);

    const path = button.getAttribute('data-save-path');
    const response = await fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('input[name="authenticity_token"]').value
      },
      body: JSON.stringify({
        api_user: credentials.apiUser,
        api_secret: credentials.apiSecret,
        api_url: credentials.apiUrl,
      })
    })
    const data = await response.json();

    button.disabled = false;
    button.innerHTML = sanitizeHtml(buttonOriginalText);

    let classes = response.ok ? "alert-success" : "alert-danger";
    show_response_alert(data.message, data.error, classes);

    // If the setting in not yet persisted and the response was ok, we remind the User to save
    if (response.ok && data.update_notice) {
      show_response_alert(data.update_notice, undefined, 'alert-info');
    }
  }

  function getCredentials(param_key) {
    const apiUser = document.querySelector(`input[name='${param_key}[api_user]']`);
    const apiSecret = document.querySelector(`input[name='${param_key}[api_secret]']`);
    const apiUrl = document.querySelector(`input[name='${param_key}[api_url]']`);

    if (apiUser && apiSecret) {
      return {
        apiUser: apiUser.value,
        apiSecret: apiSecret.value,
        apiUrl: apiUrl?.value,
      };
    } else {
      console.error('API credentials not found');
    }
  }

  function show_response_alert(message, error, classes) {
    let error_html = typeof error === 'undefined' ? '' : '<br><p class="mb-0">' + error + '</p>';
    const alertBox = document.createElement('div');
    alertBox.className = `alert alert-dismissible ${classes}`;
    alertBox.innerHTML = `
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close">
        <span aria-hidden="true"></span>
      </button>
      <strong>${message}</strong>
      ${error_html}
    `;
    document.getElementById(button.dataset.appendElement).insertAdjacentElement("afterend", alertBox);

    // Remove the alert after 5 seconds
    setTimeout(() => {
      alertBox.classList.add('fade');
      setTimeout(() => alertBox.remove(), 500);
    }, 5000);
  }
});
